<template>
<el-menu>
        <router-link to="/home" class="routerlink">
              <img src='../../public/logo.png' class="avatarimg"/>
            </router-link>
        <router-link to="/home" class="routerlink">
          <el-menu-item index="1">
            <i class="el-icon-location"></i>
            <span>主页</span>
          </el-menu-item>
        </router-link>
        <router-link to="/sitepasswd" class="routerlink">
          <el-menu-item index="2">
            <i class="el-icon-menu"></i>
            <span>密码列表</span>
          </el-menu-item>
        </router-link>
        <router-link to="/task" class="routerlink">
          <el-menu-item index="3">
            <i class="el-icon-document"></i>
            <span>任务列表</span>
          </el-menu-item>
        </router-link>
        <router-link to="/cloudecslist" class="routerlink">
            <el-menu-item index="7">
              <i class="el-icon-document"></i>
              <span>服务器列表</span>
            </el-menu-item>
          </router-link>
<!--        <router-link to="/assertlist" class="routerlink">-->
<!--            <el-menu-item index="8">-->
<!--              <i class="el-icon-document"></i>-->
<!--              <span>资产列表</span>-->
<!--            </el-menu-item>-->
<!--          </router-link>-->
          <!-- <router-link to="/stirlingpdf" class="routerlink">
          <el-menu-item index="9">
            <i class="el-icon-document"></i>
            <span>pdf</span>
          </el-menu-item>
        </router-link> -->
        <!-- <router-link to="/chat" class="routerlink">
          <el-menu-item index="4">
            <i class="el-icon-document"></i>
            <span>ChatGPT</span>
          </el-menu-item>
        </router-link> -->
        <!-- <router-link to="/config" class="routerlink">
          <el-menu-item index="5">
            <i class="el-icon-document"></i>
            <span>配置</span>
          </el-menu-item>
        </router-link> -->

<el-submenu index="rss" v-if="rssFolders.length">
       <template #title>
           <i class="el-icon-connection"></i>
           <span>订阅</span>
       </template>
       <el-submenu
           v-for="folder in rssFolders"
           :key="folder.folder"
           :index="'rss-folder-' + folder.folder"
       >
           <template #title>
               <i class="el-icon-folder"></i>
               <span>{{ folder.folder }}</span>
           </template>
           <router-link
               v-for="src in folder.sources"
               :key="src.id"
               :to="'/rss?source=' + src.id"
               class="routerlink"
           >
               <el-menu-item :index="'rss-src-' + src.id">
                   <span>{{ src.name }}</span>
               </el-menu-item>
           </router-link>
       </el-submenu>
   </el-submenu>

<el-submenu index="8">
       <template #title>
           <i class="el-icon-timer"></i>
           <span>配置</span>
       </template>
       <router-link to="/config/config_gotify" class="routerlink">
           <el-menu-item index="8-1">
               <span>配置gotify服务</span>
           </el-menu-item>
       </router-link>
       <!-- <router-link to="/scheduledtask/metadataMaintenance" class="routerlink">
           <el-menu-item index="8-2">
               <span>元数据维护</span>
           </el-menu-item>
       </router-link> -->
   </el-submenu>
<!--        <router-link to="/memoryday" class="routerlink">-->
<!--            <el-menu-item index="6">-->
<!--              <i class="el-icon-document"></i>-->
<!--              <span>纪念日倒计时</span>-->
<!--            </el-menu-item>-->
<!--          </router-link>-->
      </el-menu>
</template>

<script>
import axios from '@/config'

export default {
  name: "sideBar",
  data() {
    return {
      rssFolders: [],  // [{ folder, sources: [...] }]
    };
  },
  mounted() {
    this.fetchRssFolders()
    // 订阅源在 RssFeed 页增删后广播，侧边栏实时刷新
    this.$root.$on('rss-sources-changed', this.fetchRssFolders)
  },
  beforeDestroy() {
    this.$root.$off('rss-sources-changed', this.fetchRssFolders)
  },
  methods: {
    async fetchRssFolders() {
      try {
        const res = await axios.get('rss/sources')
        if (res.data.code === '0000') {
          this.rssFolders = res.data.data
        }
      } catch (e) { /* 未登录或接口异常时静默，不影响其它菜单 */ }
    },
  },
}
</script>

<style scoped>
/*.rotate-icon {*/
/*  transform: rotate(180deg); !* 旋转180度 *!*/
/*  transition: transform 0.3s; !* 平滑过渡 *!*/
/*}*/
.routerlink {
  color: black;
  text-decoration: none; /* 取消下划线 */

}
.el-menu {
  background-color: #faf9f5;
}
</style>